export default function ($translate, $rootScope) {
    const getLabels = () => ({
        ET: $translate.instant('enums.Estonian'),
        EN: $translate.instant('enums.English'),
        LT: $translate.instant('enums.Lithuanian')
    });

    const result = {
        KEYS: {
            ET: 'ET',
            EN: 'EN',
            LT: 'LT'
        },
        LABELS: getLabels(),
        // Header language switcher only: each language in its own language, never translated
        NAMES: {
            ET: 'Eesti',
            EN: 'English',
            LT: 'Lietuvių'
        }
    };

    // TokenService injects this enum, so it is built before the translation table has loaded
    $rootScope.$on('$translateChangeSuccess', () => {
        result.LABELS = getLabels();
    });

    return result;
}



// WEBPACK FOOTER //
// ./src/app/enums/company/admin/language/index.js